import { put, call, takeLatest } from 'redux-saga/effects';

import * as actionCreators from '../redux/actions';
import * as actionTypes from '../redux/actions/type';
import API, { ROUTES } from "../../../commons/api/api";
import {getCouponSuccess} from "../redux/actions";


function* getPoint(action) {

    try {
        const response = yield call(() =>
            API.get(ROUTES.API_POINT)
        );
        yield put(actionCreators.getPointSuccess({ data: response.data }));

    } catch (error) {

    }
}

function* getCoupon(action) {

    try {
        const response = yield call(() =>
            API.get(ROUTES.API_COUPON)
        );
        yield put(actionCreators.getCouponSuccess({ data: response.data }));

    } catch (error) {

    }
}

function* exchangePointToCoupon({payload}) {

    try {
        const response = yield call(() =>
            API.post(ROUTES.API_CHANGE_POINT_TO_COUPON, payload)
        );
        console.log(response, 'rẻsdcsdc');
        if (response.data.status) {
            yield put(actionCreators.exchangePointToCouponSuccess({ data: response.data }));
        }else{
            yield put(actionCreators.exchangePointToCouponFailed(response.data.status));
        }
    } catch (error) {
        yield put(actionCreators.exchangePointToCouponFailed(error));
    }
}


function* GiftBoxSaga() {
    yield takeLatest(actionTypes.GET_POINT, getPoint);
    yield takeLatest(actionTypes.GET_COUPON, getCoupon);
    yield takeLatest(actionTypes.EXCHANGE_POINT_TO_COUPON_REQUEST, exchangePointToCoupon);
}

export default GiftBoxSaga;
